import { render, staticRenderFns } from "./TextControls.vue?vue&type=template&id=6d55bd41&"
import script from "./TextControls.vue?vue&type=script&lang=ts&"
export * from "./TextControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports